<template>
    <IconButton
        color="carbon-purple-400"
        :icon="props.isPaused ? 'play' : 'pause'"
        :aria-label="props.isPaused ? $tr('gameContainer.play') : $tr('gameContainer.pause')"
        interfaceTarget="toggle-game-playback"
        @click="emit('click')"
    />
</template>

<script lang="ts" setup>
import IconButton from '@/components/Buttons/IconButton.vue'

const props = defineProps<{
    isPaused: boolean
}>()

const emit = defineEmits<{
    click: []
}>()
</script>
